import { DIETS } from '@monofront/business/constants';
import BadgeVegan from '@monofront/design-system/visuals/Icons/BadgeVegan';
import BadgeLactoseFree from '@monofront/design-system/visuals/Icons/BadgeLactoseFree';
import BadgeSugarFree from '@monofront/design-system/visuals/Icons/BadgeSugarFree';
import BadgeGlutenFree from '@monofront/design-system/visuals/Icons/BadgeGlutenFree';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';
import ListItem, { IValueData } from './ListItem';

interface IDietsProps {
  values: string[];
  size?: 'md' | 'lg';
  enableSidePanel?: boolean;
}

const Diets: React.FC<IDietsProps> = ({
  values,
  size = 'md',
  enableSidePanel = false,
}) => {
  const tCatalog = useTranslations('Catalog');

  const formattedDiets = useMemo(
    () => values.map((value) => value.toUpperCase()),
    [values],
  );

  const valuesData = useMemo(
    (): { [x: string]: IValueData } => ({
      [DIETS.NOSUGAR]: {
        Badge: (props) => <BadgeSugarFree {...props} />,
        label: tCatalog('tagSugarFree'),
        documentUid: 'sugar-free',
      },
      [DIETS.GLUTENFREE]: {
        Badge: (props) => <BadgeGlutenFree {...props} />,
        label: tCatalog('tagGlutenFree'),
        documentUid: 'gluten-free',
      },
      [DIETS.NOLACTOSE]: {
        Badge: (props) => <BadgeLactoseFree {...props} />,
        label: tCatalog('tagLactoseFree'),
        documentUid: 'lactose-free',
      },
      [DIETS.VEGAN]: {
        Badge: (props) => <BadgeVegan {...props} />,
        label: tCatalog('tagVegan'),
        documentUid: 'vegan',
      },
    }),
    [tCatalog],
  );

  return (
    <>
      {formattedDiets.map((value, index) => {
        const data = valuesData[value];

        if (!data) return null;

        return (
          <ListItem
            key={index}
            valueId={value}
            valueData={data}
            size={size}
            enableSidePanel={enableSidePanel}
            tagColor="tw-lf-tag-decorative-green"
          />
        );
      })}
    </>
  );
};

export default Diets;
